import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStepComplete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path fill="#5C37EB" d="M.75 8a7.25 7.25 0 1 1 14.5 0A7.25 7.25 0 0 1 .75 8" />
    <path
      stroke="#5C37EB"
      strokeWidth={1.5}
      d="M.75 8a7.25 7.25 0 1 1 14.5 0A7.25 7.25 0 0 1 .75 8Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M12.019 5.234a.8.8 0 0 1 0 1.132l-4.767 4.766a.8.8 0 0 1-1.131 0L3.954 8.966a.8.8 0 0 1 1.132-1.132l1.6 1.601 4.202-4.2a.8.8 0 0 1 1.131 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStepComplete;
